import { GenericExperienceFe } from "@intelligems/ig-types";
import { useFileBuild as _useFileBuild } from "@src/api/experience-files/file-build";
import { useGetProcesses } from "@src/api/processes/get-processes";

export const useFileBuild = ({
  experience,
}: {
  experience: GenericExperienceFe;
}) => {
  const buildPriceCsvFile = _useFileBuild();
  const processes = useGetProcesses();

  let downloadTemplateReady: {
    isReady: boolean;
    href?: string | null;
  } = { isReady: false, href: null };
  if (processes.isSuccess) {
    let sortedFileBuilds = processes.data.processes
      .filter((process) => {
        if (process.type !== "fileBuild") {
          return false;
        }
        if (experience.id && process.id.includes(experience.id)) {
          return true;
        }
        return false;
      })
      .sort((a, b) => {
        return b.startTime - a.startTime;
      });

    if (!sortedFileBuilds.length) {
      // temporary until all new processes are using the new id
      sortedFileBuilds = processes.data.processes
        .filter((process) => process.type === "fileBuild")
        .sort((a, b) => {
          return b.startTime - a.startTime;
        });
    }

    if (
      sortedFileBuilds.length &&
      !sortedFileBuilds[0].isLoading &&
      sortedFileBuilds[0].loadingPercent === 100
    ) {
      downloadTemplateReady = {
        isReady: Boolean(sortedFileBuilds[0].action?.href),
        href: sortedFileBuilds[0].action?.href,
      };
    }
  }

  return {
    buildPriceCsvFile,
    downloadTemplateReady,
  };
};
